module.exports = __webpack_public_path__ + "static/media/avatar10.5a8649c2.jpg";